import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/storage'

function uploadImage (file, id) {
  const storageRef = firebase.storage().ref()
  const imagesRef = storageRef.child(`images/${id}`)
  const fileRef = imagesRef.child(file.name)
  const metadata = {
    customMetadata: {
      dir: id
    }
  }
  return new Promise(resolve => {
    resolve(fileRef.put(file, metadata))
  })
    .then(snapshot => {
      const storage = firebase.storage().ref(snapshot.metadata.fullPath)
      return new Promise(resolve => {
        resolve(storage.getDownloadURL())
      })
        .then(url => {
          return url
        })
    })
}

export default {
  uploadImage
}
